export enum LoginState {
    IDLE,
    STARTED,
    STOPPED
}

export enum SignUpState {
    IDLE,
    STARTED,
    STOPPED
}

export enum PasswordRecoveryState {
    IDLE,
    STARTED,
    STOPPED
}
